// extracted by mini-css-extract-plugin
module.exports = {"packingItem":"nnZhC","packingItem-price":"E5Zhj","packingItem-name":"dm2Il","packingItem-overlay":"DSq9s","packingItem-checkmark":"lTgQ-","packingItem-price-value":"DsyX6"};